import {type RouteLocationStringParam} from 'vue-router';

const DashboardView = () => import('../views/dashboard/DashboardView.vue');

let dashboard = [
    {
        name: 'dashboard-index',
        path: '/dashboard/index/section/:section(\\d+)',
        component: DashboardView,
        props(route: RouteLocationStringParam)
        {
            return {
                section: parseInt(route.params.section) || 0,
            };
        },
    },
    {
        path: '/dashboard/:wildcard*',
        redirect: {
            name: 'dashboard-index',
            params: {section: '0'},
        },
    },
];

export default dashboard;